import React from "react";
import { useLanguage } from "../Translations/LenguageContext";

const TrainModel = () => {
    const { t } = useLanguage();

    return (
        <div className="brain_cont fade-in">
            <h3>{t.controlledTraining.title}</h3>
            <p className="brain_card_desc">{t.controlledTraining.desc}</p>
        </div>
    );
}

export default TrainModel;
